import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgSubtract(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="7 -4 10 24" {...props}>
      <path d="M7 8.714V7.286h10v1.428z" fill="currentColor" />
    </svg>
  );
}

export default tombacIcon('Subtract')(SvgSubtract);
